<div class="login-body">
  <div class="login-container">
    <div fxLayout="row" fxLayoutAlign="center center" class="content">
      <mat-card>
        <mat-card-header>
          <mat-card-title>SW PR GW Customer Dashboard</mat-card-title>
        </mat-card-header>

        <mat-card-content class="login-card-content">
          <form [formGroup]="loginForm" (ngSubmit)="login()">
            <mat-form-field>
              <input matInput placeholder="E-mail cím" formControlName="email">
            </mat-form-field>

            <div class="recaptcha-container">
              <re-captcha #captcha id="recaptcha" class="recaptcha" (resolved)="setRecaptchaToken($event)"
                siteKey="{{siteKey}}">
              </re-captcha>
            </div>

            <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid || !recaptchaToken">BEJELENTKEZÉS</button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>